<div class="textAreaContainer-container" style="margin-bottom: 50px">
  <div class="textAreaContainer" [style]="textAreaContainer.inlineStyle">
    <h3>{{ textAreaContainer.caption }}</h3>
    <div class="input-component-container">
      @for (textareas of textAreaContainer.containerList; track $index) {
        @if (layoutElementUtil.isTextArea(textareas)) {
          <div class="input-component">
            <app-text-area
              [textArea]="layoutElementUtil.asTextArea(textareas)"
              (diff)="computeCharcount($event)"
              [stopEditing]="charCount>=(textAreaContainer.maxChars! - 1)">
            </app-text-area>
          </div>
        }
      }
    </div>
    <div class="input-component">
      @if (textAreaContainer.maxCharsWarning && textAreaContainer.maxChars) {
        <app-character-counter
          [maxChars]="textAreaContainer.maxChars"
          [maxCharsWarning]="textAreaContainer.maxCharsWarning"
          [charSequenceLength]="charCount"
        [isArdPopnacht]="textAreaContainer.isArdPopnacht"></app-character-counter>
      }
    </div>

  </div>

</div>
